/**
 * Desplaza el panel de edición al viewport. Reintenta si el panel aún no está en el DOM
 * (p. ej. `@if` / `viewChild` tras `startEdit`).
 */
export function scrollVaultEditPanelIntoView(
  element: HTMLElement | null | undefined,
  options?: { focusSelector?: string },
): void {
  if (!element || typeof element.scrollIntoView !== 'function') return;

  element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

  const focusSelector =
    options?.focusSelector ?? 'input:not([type="hidden"]):not([disabled]), textarea:not([disabled])';
  const focusable = element.querySelector<HTMLElement>(focusSelector);
  if (!focusable || typeof focusable.focus !== 'function') return;

  window.setTimeout(() => {
    focusable.focus({ preventScroll: true });
  }, 120);
}

/** Resuelve el panel (lazy) y hace scroll cuando exista en el DOM. */
export function scrollVaultEditPanelWhenReady(
  resolve: () => HTMLElement | null | undefined,
  options?: { focusSelector?: string; maxAttempts?: number },
): void {
  const maxAttempts = options?.maxAttempts ?? 8;
  const attempt = (n: number): void => {
    const el = resolve();
    if (el) {
      scrollVaultEditPanelIntoView(el, options);
      return;
    }
    if (n >= maxAttempts) return;
    window.setTimeout(() => attempt(n + 1), 32);
  };
  attempt(0);
}
